import React, { useState } from 'react';
import dayjs from 'dayjs';
import { useRecoilValue } from 'recoil';
import { Button, Modal } from 'antd';
import { appConfigAtomState } from '../../state/reducerAtoms/app.atom';
import './index.scss';
import PageLayout from '../../features/app';
import AppTable from '../../components/table';
import SVGIcons from '../../assets/images/icons/svgIcons';
import ApiCaller from '../../services/api/general';
import { showSnackbar } from '../../components/snackbar';
import { DATE_TIME_MESSAGE_RECEIVED_FORMAT } from '../../constants';
import InboxView from './inboxView';





const MyMessagesList = () => {

    const appState = useRecoilValue(appConfigAtomState);

    const tableColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: 150,
            ellipsis: true,
            // render: (text) => <Link to={'/'}>{text}</Link>,
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            width: 200,
            ellipsis: true,

        },
        {
            title: 'Phone',
            dataIndex: 'phoneNumber',
            key: 'phoneNumber',
            width: 130,
            ellipsis: true,
        },
        {
            title: 'Subject',
            dataIndex: 'subject',
            key: 'subject',
            width: 250,
            ellipsis: true,
        },
        // {
        //     title: 'Message',
        //     dataIndex: 'query',
        //     key: 'message',
        //     width: 250,
        //     ellipsis: true,
        // },
        {
            title: 'CreatedAt',
            dataIndex: 'createdAt',
            key: 'status',
            width: 180,
            render: (createdAt) => <span>{dayjs(createdAt).format(DATE_TIME_MESSAGE_RECEIVED_FORMAT)}</span>
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 90,
            render: (status, record) => <Button style={{ fontSize: '22px' }} shape="circle" classNames={['status-btn', status]} onClick={() => updateStatus(record.id, status)}>{status === 'resolved' ? <SVGIcons.StatusActiveIcon /> : <SVGIcons.StatusInactiveIcon />}</Button>
        },
        {
            // title: 'a',
            // dataIndex: 'action view',
            key: 'actionView',
            width: 70,
            render: (text, record) => (
                <Button
                    style={{ fontSize: '17px' }}
                    shape="circle"
                    onClick={() => {                        
                        setOpenDeleteDialog(true);
                        setSelectedMessage(record);
                    }}
                >
                    <SVGIcons.EyeOpen />
                </Button>
            )
        }

    ];

    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [selectedMessage, setSelectedMessage] = useState({});

    const [isRefreshData, setIsRefreshData] = useState(false);


    const updateStatus = (id, status) => {
        const apiCaller = new ApiCaller(`inbox/${id}`);
        const updatedStatus = status === 'pending' ? 'resolved' : 'pending';
        apiCaller.updateData(id, { status: updatedStatus }).then((d) => {
            if (d.success) {
                showSnackbar().success(`Query updated successfully!`)
            }
        }).finally(() => setIsRefreshData((prv) => !prv))

    }


    const getDataURL = () => `inbox`;







    return (

        <PageLayout
            pageName={'messages'}
            pageTitle={'Messages'}
            bodyClassName={`provider-portal`}
            key={`${appState?.selectedLang}`}
        >
            <AppTable
                columns={tableColumns}
                dataURL={getDataURL()}
                isRefreshData={isRefreshData}
                isEditActionEnabled={false}
                isViewActionEnabled={false}
                isDeleteActionEnabled={false}
                actionColumnSettings={{ width: 1 }}
            />


            <Modal
                // title="sdsdsds?"
                centered
                maskClosable
                open={openDeleteDialog}
                footer={null}
                onOk={() => setOpenDeleteDialog(false)}
                onCancel={() => setOpenDeleteDialog(false)}
                className='message-modal'
            >
                <InboxView data={selectedMessage} />
            </Modal>



        </PageLayout >
    )
}
MyMessagesList.propTypes = {}

export default MyMessagesList;
